// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"3b53517f","115":"3b53517f","799":"3b53517f","842":"3b53517f","888":"3b53517f"}[chunkId] + ".chunk.css";
};